import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';

@Injectable({
    providedIn: 'root'
})
export class ClientsService {

    private baseUrl = environment.baseUrl + "/client";

    constructor(public http: HttpClient) {
    }

    create(requestModel): Observable<any> {
        return this.http.post(this.baseUrl + "/create", requestModel);
    };

    update(requestModel): Observable<any> {
        return this.http.post(this.baseUrl + "/update", requestModel);
    };

    delete(requestModel): Observable<any> {
        return this.http.post(this.baseUrl + "/delete", requestModel);
    };

    get(id: number): Observable<any> {
        return this.http.get(this.baseUrl + "/" + id);
    };

    list(filterModel): Observable<any> {
        return this.http.post(this.baseUrl + "/list", filterModel);
    };

    listAll(): Observable<any> {
        return this.http.post(this.baseUrl + "/list-all", {});
    };

    listAllForUser(): Observable<any> {
        return this.http.post(this.baseUrl + "/list-all-for-user", {});
    };
}
